import { createAsyncThunk } from "@reduxjs/toolkit";
import apiCall from "../AuthorizedApi";

export const fetchStudioConfigAPI =
    async (slug: string) => {
        try {
            const response = await apiCall({
                method: 'GET',
                url: `/project/user/get-studio-config-by-slug/?slug=${slug}`,
            })

            // console.log(response.data);
            return response;
        } catch (error: any) {
            throw error;
        }
    }


export const mediaUploadAPI = async (file: File) => {

    try {
        const formData = new FormData();
        formData.append('image', file);
        const response = await apiCall({
            method: 'POST',
            url: `/project/user/upload-config-image/`,
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data"
            }

        })

        // console.log(response.data);
        return response;
    } catch (error: any) {
        throw error;
    }
}

export const mediaDeleteApi = async (path: string) => {
    try {
        const response = await apiCall({
            method: 'POST',
            url: `/project/user/delete-config-image/`,
            data: {
                path
            }
        })

        // console.log(response.data);
        return response;
    } catch (error: any) {
        throw error;
    }
}

export const createStudioConfig = async (studioData: any) => {
    try {
        const response = await apiCall({
            method: 'POST',
            url: `/project/business/studio-configuration/update/`,
            data: {
                studio_configuration: studioData
            }
        })

        // console.log(response.data);
        return response;
    } catch (error: any) {
        throw error;
    }
}

export const getStudioConfigAPI = async () => {
    try {
        const response = await apiCall({
            method: 'GET',
            url: `/project/business/studio-configuration/update/`,
        })

        // console.log(response.data);
        return response;
    } catch (error: any) {
        throw error;
    }
}